import { deepCopy } from '@app/utils/app-utils.function'
import { ReportListQueryParameter } from '../models/report-list-query.model'
import { defaultDateRange } from './report-default-date-range.constant'

export const defaultReportQuery = {
    sortBy: 'workOrderNumber',
    isDesc: false,
    dateRange: deepCopy(defaultDateRange)
} as ReportListQueryParameter
